import  React,{useEffect} from "react";
import Summary from "./components/summary";
import TrackProgress from "./components/track_progress";
import DrawerRouterContainer from "components/newDrawer";
import { Header } from "components/Header";
import { useSetState, useTrackedState } from "store/store";
import { Block } from "baseui/block";
import useExportPdf from "hooks/useExportPdf";
import { useStyletron } from "baseui";
import BreadCrumb from "./components/breadcrumb";
import { LearnerProfile, MentorProfile } from "./components/about";
import StudentAPI from "services/requests/student_api";
import { useHistory } from "react-router-dom";

const MAIN_STYLE = (theme) => ({
  [theme.mediaQuery.small]: {
    padding: "16px",
  },
  [theme.mediaQuery.medium]: {
    padding: "40px",
  },
});

export default function TrackSummaryComponent() {
  const [css, theme] = useStyletron();
  const { exportPdf, pdfComponentRef } = useExportPdf(new Date().getFullYear());
  const setState = useSetState();
  const state = useTrackedState();
  const history = useHistory();
  let resp = {}

  async function stdentTrack() {
    let learner_email = "";
    try {
      if (localStorage.getItem("role") === "ADMIN" || localStorage.getItem("role") === "TENANT OWNER"  || localStorage.getItem("role") === "MENTOR" ) {
        learner_email = JSON.parse(localStorage.getItem("track")).email_id;
      } else if (localStorage.getItem("role") === "LEARNER") {
        learner_email = localStorage.getItem("email");
      }
      const response = await StudentAPI(
        localStorage.getItem("email"),
        learner_email
      );
      if (response.status === 200) {
        const studentOverview = response.data[0]?.learner_profile_list[0];
        localStorage.setItem(
          "learner_data",
          response.data[0].learner_profile_list.length
        );
        if (response.data[0].learner_profile_list.length > 0) {
          localStorage.setItem("track", JSON.stringify(studentOverview));
          setState(
            (prev) => ({
              ...prev,
              track: studentOverview,
              isFetchTrackData: true,
            }),
            () => {
              resp = localStorage.getItem("track");
            }
          );
        } else {
          history.push("/landing");
        }
      } else {
        console.log("something went wrong");
        history.push("/landing");
      }
    } catch (e) {
      console.log(e);
      setState((prev) => ({
        ...prev,
        track: {},
        isFetchTrackData: false,
      }));
    }
  }


 useEffect(() => {
   if(!state.isFetchTrackData){
    stdentTrack();
   }
  }, []);

  if (state?.track) {
    localStorage.setItem("track", JSON.stringify(state.track));
  }
  resp = JSON.parse(localStorage.getItem("track"));
  return (
    <Block>
      <Header />
      <DrawerRouterContainer>
        <Block className={css(MAIN_STYLE(theme))}>
          <BreadCrumb exportPdf={exportPdf} user={resp || {}} />
          <Block ref={pdfComponentRef}>
            <Summary track={resp} />
            <Block
              display="flex"
              flexDirection={["column", "column", "column", "row"]}
              gridGap={["16px", "16px", "20px"]}
            >
              <Block flex="1">
                <TrackProgress />
              </Block>
              <Block
                width={["initial", "initial", "initial", "20%"]}
                display="flex"
                flexDirection="column"
                gridGap="20px"
              >
                <LearnerProfile track={resp} />
                <MentorProfile track={resp} />
              </Block>
            </Block>
          </Block>
        </Block>
      </DrawerRouterContainer>
    </Block>
  );
}
